/* global woocommerce_params */

export default {
    init() {
        // console.log('CART');

        // Plus/minus przy ilosci. Pole jest zablokowane (pointer-events:
        // none), przycisk "Aktualizuj koszyk" ukryty - jedyna droga zmiany
        // ilosci to te przyciski, a zadnego skryptu za nimi nie bylo
        // (product.js dziala tylko na body.single-product). Po zmianie
        // klikamy ukryty update_cart z opoznieniem, zeby kilka szybkich
        // klikniec zebralo sie w jedna aktualizacje.
        let qtyTimer;

        $(document).on('click', '.woocommerce-cart-form .quantity .plus, .woocommerce-cart-form .quantity .minus', function() {
            const $button = $(this);
            const $input = $button.closest('.quantity').find('input.qty');
            const step = parseFloat($input.attr('step')) || 1;
            const min = parseFloat($input.attr('min'));
            const max = parseFloat($input.attr('max'));
            const obecna = parseFloat($input.val()) || 0;

            let nowa = $button.hasClass('plus') ? obecna + step : obecna - step;
            nowa = Math.max(nowa, Number.isNaN(min) ? 0 : min);

            if (!Number.isNaN(max) && max > 0) {
                nowa = Math.min(nowa, max);
            }

            if (nowa === obecna) {
                return;
            }

            $input.val(nowa).trigger('change');

            // Wyszarzenie + spinner (CSS .is-updating) od razu po kliknieciu;
            // znika samo wraz z przeladowaniem strony po aktualizacji.
            $button.closest('form.woocommerce-cart-form').addClass('is-updating');

            clearTimeout(qtyTimer);
            qtyTimer = setTimeout(() => {
                $("button[name='update_cart']").trigger('click');
            }, 650);
        });

        $(document).on('click', '.remove-button', function(e) {
            e.preventDefault();
            
            var $button       = $(this);
            var cartItemKey   = $button.data('cart_item_key');
    
            // Adres AJAX WooCommerce:
            var ajaxUrl = woocommerce_params.wc_ajax_url
                .toString()
                .replace('%%endpoint%%', 'my_remove_cart_item'); 
                // <-- 'my_remove_cart_item' to nasza własna akcja (patrz Krok 4)
    
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    cart_item_key: cartItemKey,
                },
                success: function(response) {
                    if (response && !response.error) {
                        // Wywołujemy wbudowane odświeżenie fragmentów koszyka w WooCommerce
                        $(document.body).trigger('wc_update_cart');
                    }
                },
                error: function(xhr, status, error) {
                    console.log('Błąd przy usuwaniu z koszyka:', error);
                },
            });
        });

    },
}



// WEBPACK FOOTER //
// ./scripts/routes/cart.js